/* Miaoutfit · Project Feline · interactions (23/10/2026)
   - Apparitions au défilement (data-mo-reveal, data-mo-img, data-mo-pills), une seule fois.
   - Copie du code promo, ensembles « Tout ajouter », petit rebond du panier.
   Respecte prefers-reduced-motion ; aucun blocage du défilement. */
(function () {
  'use strict';
  if (window.moFeline) return;
  window.moFeline = true;

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Apparitions ---------- */
  var SEL = '[data-mo-reveal], [data-mo-img], [data-mo-pills], .mo-under';
  var io = null;
  function show(el) { el.classList.add('is-in'); }
  function observe(scope) {
    var els = (scope || document).querySelectorAll(SEL);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(show); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------- Argent ---------- */
  function money(cents, format) {
    cents = Math.round(cents);
    var fmt = format || '{{amount_with_comma_separator}} €';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount_with_comma_separator';
    function sep(n, d, t, dec) {
      var s = (n / 100).toFixed(d);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return d ? p[0] + dec + p[1] : p[0];
    }
    var v;
    switch (kind) {
      case 'amount': v = sep(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = sep(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = sep(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = sep(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = sep(cents, 2, ' ', ','); break;
      default: v = sep(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- Ensembles ---------- */
  function setTotals(set) {
    var wrap = set.closest('[data-money-format]');
    var fmt = wrap ? wrap.getAttribute('data-money-format') : null;
    var pct = wrap ? parseFloat(wrap.getAttribute('data-pct') || '0') : 0;
    var total = 0, count = 0;
    set.querySelectorAll('[data-mo-set-item]').forEach(function (it) {
      var f = it.querySelector('[data-mo-variant]');
      if (!f) return;
      var price = f.tagName === 'SELECT' ? f.options[f.selectedIndex].getAttribute('data-price') : f.getAttribute('data-price');
      price = parseInt(price || '0', 10);
      total += price; count++;
      var pe = it.querySelector('[data-mo-price]');
      if (pe) pe.textContent = money(price, fmt);
    });
    var t = set.querySelector('[data-mo-total]');
    if (t) t.textContent = money(total, fmt);
    var d = set.querySelector('[data-mo-disc]');
    if (d) {
      d.textContent = money(total * (100 - pct) / 100, fmt);
      d.parentElement.hidden = !(pct > 0 && count >= 3);
    }
  }

  function addItems(items, btn) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.getAttribute('data-adding') || '…';
    var p = fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer-section' })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (j) {
        return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { return { detail: { sections: j.sections || {}, itemCount: c.item_count } }; });
      });
    if (location.pathname.indexOf('/cart') === 0) {
      p.then(function () { location.reload(); }, function () { location.reload(); });
      return;
    }
    var ev = new Event('shopify:cart:lines-update', { bubbles: true });
    ev.promise = p;
    document.dispatchEvent(ev);
    p.then(function () {
      btn.removeAttribute('aria-busy');
      btn.classList.add('is-done');
      btn.textContent = btn.getAttribute('data-added') || label;
      bump();
      setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 2600);
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      btn.textContent = btn.getAttribute('data-error') || label;
      setTimeout(function () { btn.textContent = label; }, 2600);
    });
  }

  /* ---------- Panier : rebond ---------- */
  function bump() {
    if (reduce) return;
    document.querySelectorAll('.cart-bubble, cart-icon').forEach(function (el) {
      el.classList.remove('mo-bump');
      void el.offsetWidth;
      el.classList.add('mo-bump');
    });
  }
  document.addEventListener('cart:update', bump);

  /* ---------- Événements ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-mo-set] select[data-mo-variant]');
    if (s) setTotals(s.closest('[data-mo-set]'));
  });

  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-mo-copy]');
    if (c) {
      var code = c.getAttribute('data-mo-copy');
      var done = function () {
        c.setAttribute('data-state', c.getAttribute('data-mo-copied') || '✓');
        setTimeout(function () { c.removeAttribute('data-state'); }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
      return;
    }
    var b = e.target.closest && e.target.closest('[data-mo-add-set]');
    if (b) {
      e.preventDefault();
      var set = b.closest('[data-mo-set]');
      var items = [];
      set.querySelectorAll('[data-mo-variant]').forEach(function (f) {
        var id = parseInt(f.value, 10);
        if (id) items.push({ id: id, quantity: 1 });
      });
      if (items.length) addItems(items, b);
    }
  });

  /* ---------- En-tête : ombre légère après défilement ---------- */
  /* Horizon fait défiler .page-wrapper sur ordinateur et le document sur mobile */
  var ticking = false;
  function curY() {
    var pw = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('mo-scrolled', curY() > 12);
      ticking = false;
    });
  }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  /* ---------- Démarrage ---------- */
  function init() {
    observe(document);
    document.querySelectorAll('[data-mo-set]').forEach(setTotals);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
    e.target.querySelectorAll('[data-mo-set]').forEach(setTotals);
  });
})();
